import React, { useContext, useEffect, useState } from "react";
import { apiPut, apiDelete, apiGet } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import { isEmpty } from "lodash";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillDelete, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../../utils/helpers";
import { NavLink, useLocation } from "react-router-dom";
import AuthContext from "context/AuthContext";
import dayjs from "dayjs";
import Pagination from "pages/Pagination";

const List = ({ userDetails }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const location = useLocation();
  const { logoutUser, user } = useContext(AuthContext);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [items, setAllItems] = useState([]);
  const [userData, setUserData] = useState(
    !isEmpty(location.state?.userDetails)
      ? location.state?.userDetails
      : userDetails
  );
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [filterData, setFilterData] = useState({
    status: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });
  const manager =
    user?.permission?.find((e) => e.manager === "customers") ?? {};

  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "active" ? "inactive" : "active",
      };
      const path = `${apiPath.sellItemStatusChange}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allSellItemList();
      }
      // }
    } catch (error) {
      console.log("error in get all reports list==>>>>", error.message);
    }
  };

  const allSellItemList = async (data) => {
    try {
      const { status, startDate, endDate, searchKey, isFilter } = filterData;
      const payload = {
        page,
        pageSize,
        status,
        start_date: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        end_date: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        keyword: searchKey,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        flag: "list",
      };

      const path = apiPath.sellItemByUserId + "/" + userData?._id;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setAllItems(response?.docs);
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null,
        });
      }
    } catch (error) {
      console.log("error ", error);
      setPaginationObj({});
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };

  const handleSearchKey = (e) => {
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true });
    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      status: "",
      searchKey: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setIsDelete(true);
  };
  const statusPage = (e) => {
    setFilterData({ ...filterData, status: e.target.value, isFilter: true });
    setPage(1);
    setIsDelete(true);
  };

  useEffect(() => {
    allSellItemList();
  }, [page, filterData, sort]);

  return (
    <div className="py-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                #
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortKey === "itemName" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "itemName",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "itemName",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex ">
                  <span>{t("O_ITEM_NAME")} </span>
                  <span>
                    {sort.sortKey === "itemName" && sort.sortType === "asc" && (
                      <BsArrowUpShort className="w-4 h-4" />
                    )}
                    {sort.sortKey === "itemName" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortKey === "itemPrice" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "itemPrice",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "itemPrice",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex ">
                  <span>{t("O_ITEM_PRICE")} (৳) </span>
                  <span>
                    {sort.sortKey === "itemPrice" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "itemPrice" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                <div className="text-right">
                  <span>{t("O_CATEGORY")}</span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                <div className="text-right">
                  <span>{t("O_SUBCATEGORIES")}</span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortKey === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-end">
                  <span>{t("O_CREATED_AT")}</span>
                  <span>
                    {sort.sortKey === "createdAt" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "createdAt" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortKey === "createdAt" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-end">
                  <span>{t("O_UPDATED_AT")}</span>
                  <span>
                    {sort.sortKey === "updatedAt" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "updatedAt" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_STATUS")}
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                <div className="text-right">
                  <span>{t("O_APPROVAL_STATUS")}</span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {items &&
              items?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  {/* <td className='py-4 px-6 border-r text-right'>
                    {item?.userUniqueId}
                  </td> */}
                  <td className="py-4 px-6 border-r">{item?.itemName}</td>
                  <td className="py-4 px-6 border-r text-right">
                    {item?.itemPrice}
                  </td>
                  <td className="py-4 px-6 border-r text-right">
                    {item?.categoryDetails?.title}
                  </td>
                  <td className="py-4 px-6 border-r text-right">
                    {item?.subCategoryDetails?.title}
                  </td>
                  <td className="py-4 px-6 border-r text-right">
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.updatedAt)}
                  </td>
                  {(manager?.add || user?.role === "admin") && (
                    <td className="py-4 px-6 border-r text-center">
                      <label
                        className="inline-flex relative items-center cursor-pointer"
                        title={`${
                          item?.status === "active" ? "Active" : "Inactive"
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={item?.status === "active"}
                          onChange={(e) =>
                            helper.alertFunction(
                              `${t('ARE_YOU_SURE')} ${
                                e.target.checked ? t('O_ACTIVE_SMALL') : t('O_INACTIVE_SMALL')
                              } ${item.itemName}`,
                              item,
                              handelStatusChange
                            )
                          }
                          // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                  <td className="py-4 px-6 border-r text-right text-sm">
                    {item?.approvalStatus === "accepted" ? (
                      <span className="text-green-500">{t("O_ACCEPTED")}</span>
                    ) : (
                      <span className="text-red-500">{t("O_REJECTED")}</span>
                    )}
                  </td>
                  <td className="py-4 px-6 border-l">
                    <div className="">
                      <ul className="flex justify-center">
                        <>
                          <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <NavLink
                              title={t("O_VIEW_USER")}
                              to="/users/user-sell-item"
                              state={{
                                item,
                                tabFrom: "list",
                                userDetails: userData,
                              }}
                            >
                              {" "}
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </NavLink>
                          </li>
                          {item?.approvalStatus === "accepted" && (
                            <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <NavLink
                                to={`/users/user-sell-item-edit`}
                                state={{
                                  item,
                                  tabFrom: "list",
                                  userDetails: userData,
                                }}
                                title={t("O_EDIT")}
                              >
                                {" "}
                                <AiFillEdit className="w-5 h-5 text-slate-600" />
                              </NavLink>
                            </li>
                          )}
                        </>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(items) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={10}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
        {paginationObj?.totalItems ? (
          <Pagination
            handlePageClick={handlePageClick}
            options={paginationObj}
            isDelete={isDelete}
            page={page}
          />
        ) : null}
      </div>
    </div>
  );
};

export default List;
